module.exports = __webpack_public_path__ + "static/img/SketchPng431f51627a75304e4f7bdc740daea2ebf78fb17e5f0762409853e83c5cf838dc.43310dd0.png";